/* LOVEQUEEN - Magnifier Image Zoom (PC only) */
(function () {
  'use strict';

  var ZOOM_FACTOR = 2;
  var LENS_SIZE = 240;

  function initZoom() {
    var selectors = [
      '.product-media img',
      '.product-single__media img',
      '.product__media img',
      '.product-image img',
      '.product-gallery img',
      '[data-product-media] img',
      '.product-single__photo img'
    ];

    var images = document.querySelectorAll(selectors.join(', '));

    images.forEach(function (img) {
      if (img.dataset.lqZoomInit) return;
      img.dataset.lqZoomInit = '1';

      var parent = img.closest('.product-media-image, .product-media__image-wrapper, .product__media-item, .product-single__media, .product-image, [data-product-media], [data-media-id]') || img.parentElement;
      if (!parent) return;
      parent.classList.add('LQ-ZoomTarget');

      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
        return;
      }

      var lens = document.createElement('div');
      lens.className = 'LQ-ZoomLens';
      parent.appendChild(lens);

      function getZoomImageUrl() {
        var src = img.currentSrc || img.src;
        src = src.replace(/_(\d+)x(\d+)?\./, function (m, w) {
          var newW = Math.min(parseInt(w) * 2, 2048);
          return '_' + newW + 'x.';
        });
        return src;
      }

      img.addEventListener('mouseenter', function () {
        lens.style.backgroundImage = 'url(' + getZoomImageUrl() + ')';
        lens.style.display = 'block';
      });

      img.addEventListener('mouseleave', function () {
        lens.style.display = 'none';
      });

      /* 枠内で実際に画像が描かれている範囲（object-fit / object-position を考慮） */
      function displayedArea(rect) {
        var nw = img.naturalWidth, nh = img.naturalHeight;
        var rw = rect.width, rh = rect.height;
        if (!nw || !nh || !rw || !rh) return { x: 0, y: 0, w: rw, h: rh };
        var cs = window.getComputedStyle(img);
        var fit = cs.objectFit || 'fill';
        var sc;
        if (fit === 'cover') sc = Math.max(rw / nw, rh / nh);
        else if (fit === 'contain') sc = Math.min(rw / nw, rh / nh);
        else if (fit === 'scale-down') sc = Math.min(1, Math.min(rw / nw, rh / nh));
        else if (fit === 'none') sc = 1;
        else return { x: 0, y: 0, w: rw, h: rh }; /* fill */
        var dw = nw * sc, dh = nh * sc;
        var pos = (cs.objectPosition || '50% 50%').split(' ');
        function frac(v) { if (!v) return 0.5; if (v.indexOf('%') > -1) return parseFloat(v) / 100; if (v === 'left' || v === 'top') return 0; if (v === 'right' || v === 'bottom') return 1; return 0.5; }
        var px = frac(pos[0]), py = frac(pos[1] || pos[0]);
        return { x: (rw - dw) * px, y: (rh - dh) * py, w: dw, h: dh };
      }

      img.addEventListener('mousemove', function (e) {
        var rect = img.getBoundingClientRect();
        var area = displayedArea(rect);
        var x = e.clientX - rect.left - area.x;
        var y = e.clientY - rect.top - area.y;
        if (x < 0 || y < 0 || x > area.w || y > area.h) { lens.style.display = 'none'; return; }
        lens.style.display = 'block';

        var size = Math.min(LENS_SIZE, area.w, area.h);
        var lensX = area.x + x - size / 2;
        var lensY = area.y + y - size / 2;
        lensX = Math.max(area.x, Math.min(lensX, area.x + area.w - size));
        lensY = Math.max(area.y, Math.min(lensY, area.y + area.h - size));

        lens.style.left = lensX + 'px';
        lens.style.top = lensY + 'px';
        lens.style.width = size + 'px';
        lens.style.height = size + 'px';

        /* 拡大画像は表示中の画像領域を基準に、元の縦横比のまま拡大 */
        var bgW = area.w * ZOOM_FACTOR;
        var bgH = area.h * ZOOM_FACTOR;
        var bgX = -(x * ZOOM_FACTOR - size / 2);
        var bgY = -(y * ZOOM_FACTOR - size / 2);
        lens.style.backgroundSize = bgW + 'px ' + bgH + 'px';
        lens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoom);
  } else {
    initZoom();
  }

  document.addEventListener('shopify:section:load', initZoom);
})();
